<div [style]="reportLineStyle"
  [style.top]="reportLine.top" [style.left]="reportLine.left" [style.width]="reportLine.width" [style.height]="reportLine.height"
  [style.z-index]="reportLine.zIndex" [style.border-top-style]="reportLine.borderTopStyle" [style.border-top-color]="reportLine.borderTopColor"
  [style.border-left-style]="reportLine.borderLeftStyle" [style.border-left-color]="reportLine.borderLeftColor"></div>
